import { useApolloClient } from '@vue/apollo-composable'
import { authBySessionUnderAttack } from 'boot/init-core/auth-by-session-under-attack.js'
import { processSlugAuth } from 'boot/init-core/handle-auth/process-slug-auth.js'
import {
  consumeSocialAuthRedirectState,
  getSocialAuthRedirectState,
} from 'boot/init-core/handle-auth/social-auth-redirect.js'
import { BASE_URL } from 'common/config.js'
import { getLocale, isWebView, openNewMirror } from 'common/functions.js'
import { initCDA } from 'core/hooks/init-cda.js'
import { reachCheckpoint } from 'hooks/usePerfStep.js'
import { useUserAuthStore } from 'stores/user/auth.js'
import { getConfig } from '@/configs/index.js'

const config = getConfig()

const isProduction = process.env.NODE_ENV === 'production' && process.env.ENVIRONMENT === 'production'

export async function handleAuth({ user, token, type, router, urlPath, session, mirror }) {
  reachCheckpoint('app.boot.init_core.auth_handle_start')

  const url = urlPath.replace(BASE_URL, '')
  const route = router.resolve(decodeURIComponent(url))

  if (token && user) {
    const authStore = useUserAuthStore()

    authStore.updateUser(user)
    authStore.updateToken(token)

    const { resolveClient } = useApolloClient()
    const apolloClient = resolveClient()

    if (config.useMirrors && mirror && !isWebView && isProduction) {
      const socialRedirectPath = type === 'socialAuth' ? getSocialAuthRedirectState().redirectPath : null

      await openNewMirror(mirror, apolloClient, {
        ...route.query,
        mirror_locale: getLocale(),
        path: route.query.path || socialRedirectPath || route.path,
      })
      return
    }

    await initCDA(apolloClient)

    if (type === 'localAuth') {
      if (route.path.includes('/accounts/login/')) {
        return processSlugAuth({ router, urlPath })
      }
    }
    if (type === 'slugAuth') {
      return processSlugAuth({ router, urlPath })
    }
    if (type === 'socialAuth') {
      return consumeSocialAuthRedirectState().redirectPath
    }
    return
  }

  if (type === 'slugAuth') {
    if (route.path.includes('/accounts/login/')) {
      return processSlugAuth({ router, urlPath })
    }
  }

  if (type === 'sessionAuth') {
    if (session) {
      return authBySessionUnderAttack({ router, urlPath, session })
    }
  }
}
